import { Directive, ElementRef, EventEmitter, Output, Renderer2 } from '@angular/core';
import { SegmentLabels } from '@se/cp.common';
import { IAnatomicMap } from '../../models/IAnatomicMap';
import { IArc } from '../../models/IArc';
import { IColorData } from '../../models/IColorData';
import { IPolyline } from '../../models/ILine';
import { IPoint } from '../../models/IPoint';
import { ISegmentItem } from '../../models/ISegmentItem';
import { MapDrawerService } from '../../services/mapDrawerService/mapDrawer.service';

@Directive({
    selector: '[anatomicMapDirective]',
    standalone: true,
})
export class AnatomicMapDirective {
    @Output()
    public segmentSelected = new EventEmitter<string>();
    private actualMap: HTMLOrSVGElement;
    private maxCoordinates: IPoint;
    private svgEl: SVGElement;
    private difference = 50;

    constructor(
        private drawer: MapDrawerService,
        private renderer: Renderer2,
        private svgElRef: ElementRef,
    ) {
        this.svgEl = svgElRef.nativeElement;
        if (svgElRef.nativeElement.id === 'svg-icon-button') {
            alert();
        }
    }

    private get viewBoxCoo(): IPoint {
        return {
            x: this.maxCoordinates.x + this.difference,
            y: this.maxCoordinates.y + this.difference,
        };
    }

    public loadOrUpdateMap(
        newMap: IAnatomicMap,
        data: IColorData[],
        segmentLabel: SegmentLabels,
        isWithTooltip: boolean,
    ): void {
        if (this.actualMap) {
            this.renderer.removeChild(this.svgEl, this.actualMap);
        } else {
            // first time
            this.maxCoordinates = this.calculateMaxCoordinates(newMap);
            this.correctBoard(newMap); // ALLINEAMENTO B34 - CURVE DI BEZIER
            //this.correctBoard();
        }
        this.actualMap = this.drawer.drawMap(newMap, data, segmentLabel, isWithTooltip, this.viewBoxCoo);
        this.addMapToView(this.actualMap);
    }

    public onAnatomicMapClick() {
        const clickPoint = this.svgEl.querySelector('circle') as SVGCircleElement;
        if (clickPoint) {
            this.segmentSelected.emit(clickPoint.getAttribute('fatherId'));
            console.log('fatherId: ', clickPoint.getAttribute('fatherId'));
            console.log('clickPoint: ', clickPoint);
            clickPoint.remove();
        } else {
            this.segmentSelected.emit(null);
        }
    }

    //private correctBoard() {
    //    const { x, y } = this.viewBoxCoo;
    //    this.correctViewBox(x, y);
    //    this.correctMapText(x);
    //}

    // ALLINEAMENTO B34 - CURVE DI BEZIER

    private addMapToView(map: HTMLOrSVGElement) {
        this.renderer.appendChild(this.svgEl, map);
    }

    // ALLINEAMENTO B34 - CURVE DI BEZIER

    private async getImgSize(url: string): Promise<IPoint> {
        const img = new Image();
        img.src = url;
        await img.decode();
        return { x: img.naturalWidth, y: img.naturalHeight };
    }

    private correctBoard(map: IAnatomicMap) {
        if (!!map.vectaVersion && map.vectaVersion === 2) {
            // TODO Francesco G.: valutare l'impatto di questa modifica
            this.getImgSize(map.pathImg).then((imgSize) => {
                const { x, y } = imgSize;
                this.correctViewBox(x, y);
                this.correctMapText(x);
            });
        } else {
            const { x, y } = this.viewBoxCoo;
            this.correctViewBox(x, y);
            this.correctMapText(x);
        }
    }

    private correctViewBox(x: number, y: number) {
        this.renderer.setAttribute(this.svgEl, 'viewBox', `0 0 ${x} ${y}`);
    }

    private correctMapText(size: number) {
        const minFontSize = 10;
        const maxFontSize = 24;
        const fontsizeCalc = Math.min(Math.max(Math.round(size / 18), minFontSize), maxFontSize) + 'px';
        this.renderer.setAttribute(this.svgElRef.nativeElement, 'font-size', fontsizeCalc);
    }

    private calculateMaxCoordinates(map: IAnatomicMap): IPoint {
        const output = { x: 50, y: 50 };
        map.segmentCollection.forEach((seg: ISegmentItem) => {
            seg.pieces.forEach((p) => {
                if ('center' in p) {
                    this.checkArcMaxCoo(p, output);
                } else {
                    this.checkLineMaxCoo(p, output);
                }
            });
        });
        return output;
    }

    private checkArcMaxCoo(piece: IArc, actual: IPoint): void {
        this.substituteValueIfSmaller(piece.center, actual);
        this.substituteValueIfSmaller(piece.center, actual);
        this.substituteValueIfSmaller(piece.start, actual);
        this.substituteValueIfSmaller(piece.start, actual);
        if (piece.end) {
            this.substituteValueIfSmaller(piece.end, actual);
            this.substituteValueIfSmaller(piece.end, actual);
        }
    }

    private checkLineMaxCoo(piece: IPolyline, actual: IPoint): void {
        piece.points.forEach((p) => {
            this.substituteValueIfSmaller(p, actual);
            this.substituteValueIfSmaller(p, actual);
        });
    }

    // @HostListener('click', ['$event'])
    // private _(e: Event){
    //     e.stopPropagation();
    //     this.onAnatomicMapClick();
    // }

    private substituteValueIfSmaller(newV: IPoint, OldV: IPoint): void {
        if (newV.x > OldV.x) {
            OldV.x = newV.x;
        }
        if (newV.y > OldV.y) {
            OldV.y = newV.y;
        }
    }
}
